import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

// 外部用工
import ExternalApply from '../views/ExternalEmployment/apply.vue'
import ExternalQuery from '../views/ExternalEmployment/query.vue'
import ApproveQuery from '../views/ExternalEmployment/approveQuery.vue'
import ExterIndex from '../views/ExternalEmployment/applyIndex.vue'

Vue.use(VueRouter)

const routes = [{
	path: '/',
    name: 'index',
    component: Home,
    redirect: { name: 'ExternalApply' },
	children:[{
		path: '/',
		name: 'Home',
		component: Home,
		redirect: { name: 'ExternalApply' },
	},
	{
		path: '/ExterIndex',
		name: 'ExterIndex',
		component: ExterIndex,
	},
	{
		path: '/ExternalApply',
		name: 'ExternalApply',
		component: ExternalApply,
	},
	{
		path: '/ExternalQuery',
		name: 'ExternalQuery',
		component: ExternalQuery,
	},
	{
		path: '/ApproveQuery',
		name: 'ApproveQuery',
		component: ApproveQuery,
	}],
}]

const router = new VueRouter({
    routes,
})

export default router
